export default function PhoneString(phone) {
  return `(XX) XXXXX-${phone.substr(-4)}`;
}
